import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { UserOutlined } from '@ant-design/icons'
import { Menu, Dropdown, Avatar, Badge } from 'antd'
import { CheckCircleTwoTone } from '@ant-design/icons'

import styles from './style.module.scss'

const mapStateToProps = ({ user, settings }) => ({ user, settings })

const ProfileMenu = ({ dispatch, user, settings }) => {
    const [count] = useState(0)
    const [isFlareInternalUser, setIsFlareInternalUser] = useState(user.email.includes('@flarehr.com'))


  const logout = e => {
    e.preventDefault()
    dispatch({
      type: 'user/LOGOUT',
    })
  }

  const addCount = () => {
    // setCount(count + 1)
  }

  function handleUpdateEnvironment(environment) {
      dispatch({
          type: 'settings/CHANGE_SETTING',
          payload: {
              setting: 'environment',
              value: environment,
          },
      })
    }

  const menu = (
    <Menu selectable={false}>
      <Menu.Item key={1}>
        <strong>
          <FormattedMessage id="topBar.profileMenu.hello" />, {user?.email?.split('@')[0] || 'Anonymous'}
        </strong>

      </Menu.Item>

      <Menu.Divider />

        {isFlareInternalUser &&
        <>
            <Menu.Item key="sandbox" onClick={() => handleUpdateEnvironment('sandbox')}>
                { settings.environment === 'sandbox' &&
                <>
                    <CheckCircleTwoTone twoToneColor="#52c41a" />

                    <strong className="text-capitalize text-success ml-1">Sandbox environment</strong>
                </>
                }
                { settings.environment !== 'sandbox' && <span>Sandbox environment</span> }
            </Menu.Item>

            <Menu.Item key="test" onClick={() => handleUpdateEnvironment('test')}>
                { settings.environment === 'test' &&
                <>
                    <CheckCircleTwoTone twoToneColor="#52c41a" />

                    <strong className="text-capitalize text-success ml-1">Test environment</strong>
                </>
                }
                { settings.environment !== 'test' && <span>Test environment</span> }

            </Menu.Item>

            <Menu.Item key="autodev" onClick={() => handleUpdateEnvironment('autodev')}>
                { settings.environment === 'autodev' &&
                <>
                    <CheckCircleTwoTone twoToneColor="#52c41a" />

                    <strong className="text-capitalize text-success ml-1">Auto-dev environment</strong>
                </>
                }
                { settings.environment !== 'autodev' && <span>Auto-dev environment</span> }
            </Menu.Item>

            <Menu.Divider />
        </>
        }

      <Menu.Item key={2}>
        <a href="#" onClick={logout}>
          <i className={`${styles.menuIcon} fe fe-log-out`} />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <Dropdown overlay={menu} trigger={['click']} onVisibleChange={addCount}>
      <div className={styles.dropdown}>
        <Badge count={count}>
          <Avatar className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} />
        </Badge>
      </div>
    </Dropdown>
  )
}

export default connect(mapStateToProps)(ProfileMenu)
